import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import RadialBarChart from "./RadialBarChart";
import { get_harmony_ring_information_api } from "src/DAL/Programmes/Programmes";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { useSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import GrFilterDrawer from "src/design-system/components/GrFilterDrawer";
import VideoFilter from "../Video/VideoFilter";
import icons from "src/design-system/icons";
import GrFilterButton from "src/design-system/components/GrFilterButton";
import GrActiveFilters from "src/design-system/components/GrActiveFilters";
import { bms_date_format } from "src/utils/constants";
import moment from "moment";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const MemberChartInfo = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [programmesData, setProgrammesData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { userInfo } = useContentSetting();
  const params = useParams();

  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const getTodayDate = () => {
    const today = new Date();
    return today;
  };

  const getOneMonthAgoDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    return date;
  };

  const EMPTY_FILTER = {
    start: getOneMonthAgoDate(),
    end: getTodayDate(),
  };

  const handleSelectOther = (name, value) => {
    setFilterData((values) => ({ ...values, [name]: value }));
  };

  const [filterData, setFilterData] = useState(EMPTY_FILTER);
  const [updateFilterData, setUpdateFilterData] = useState(EMPTY_FILTER);

  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
  };

  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  const getProgrammesList = async (filterData) => {
    setIsLoading(true);
    let postData = { ...filterData };
    if (postData.start) {
      postData.start = moment(postData.start).format("YYYY-MM-DD");
    }
    if (postData.end) {
      postData.end = moment(postData.end).format("YYYY-MM-DD");
    }

    handleCloseFilterDrawer();
    const result = await get_harmony_ring_information_api(
      params.program_id,
      userInfo._id,
      postData.start,
      postData.end,
    );
    if (result.code === 200) {
      setProgrammesData(result.harmony_ring_date);
      let chipData = { ...filterData };

      if (chipData.start && chipData.end) {
        let date = `Start Date : ${bms_date_format(
          chipData.start,
        )} End Date :  ${bms_date_format(chipData.end)}`;
        chipData.date = {
          chip_label: date,
          chip_value: date,
        };
        delete chipData.start;
        delete chipData.end;
      }

      setUpdateFilterData(chipData);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const searchFunction = () => {
    if (!filterData.start && !filterData.end) {
      enqueueSnackbar("Please select date", { variant: "error" });
      return;
    }
    if (filterData.start && filterData.end) {
      getProgrammesList(filterData);
    }
  };

  const handleClearFilter = () => {
    getProgrammesList(EMPTY_FILTER);
    setFilterData(EMPTY_FILTER);
    setUpdateFilterData(EMPTY_FILTER);
  };

  const handleDeleteChip = () => {
    getProgrammesList(EMPTY_FILTER);
    setUpdateFilterData(EMPTY_FILTER);
    setFilterData(EMPTY_FILTER);
  };

  useEffect(() => {
    getProgrammesList(filterData);
  }, []);

  // The applied range as one chip (its label is built in getProgrammesList); × = back to the last 7 days.
  const activeFilters = updateFilterData?.date
    ? [
        {
          key: "date",
          icon: icons.calendar,
          label: updateFilterData.date.chip_label,
          onClear: handleDeleteChip,
        },
      ]
    : [];

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container">
      <div clas sName="row">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <IconButton
              className="back-screen-button mb-0 me-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <div>
              <h2>Weekly Task Progress</h2>
              <p>
                By default, the graph shows your task completion data from the
                past 7 days.
              </p>
            </div>
          </div>
          <GrFilterButton
            className="me-2 mt-1 mb-4"
            onClick={handleOpenFilterDrawer}
            count={activeFilters.length}
          >
            Filters
          </GrFilterButton>
        </div>
        <div className="my-3">
          <GrActiveFilters filters={activeFilters} onOpen={handleOpenFilterDrawer} />
        </div>
        <div className="col-12 mt-3">
          <RadialBarChart programmesData={programmesData} />
        </div>
      </div>
      <GrFilterDrawer
        open={filterDrawerState}
        onClose={handleCloseFilterDrawer}
        title="Filters"
        onClear={handleClearFilter}
        clearLabel="Reset"
        onApply={searchFunction}
        applyLabel="Apply"
      >
        <VideoFilter filterData={filterData} handleSelectOther={handleSelectOther} />
      </GrFilterDrawer>
    </div>
  );
};

export default MemberChartInfo;
